import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const SidebarHeaderContainer = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._12};
  position: relative;

  @media (max-width: 750px) {
    height: 40px;
    max-height: 40px;
    min-height: 40px;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};

  a {
    transition: 200ms;

    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.green[500]};
    }
  }
`;

export const CollapseArrowWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: -32px;
  background-color: ${({ theme }) => theme.neutral[950]};

  @media (max-width: 750px) {
    right: 0;
  }
`;
